import { LmsTrainingOrder } from "generated/CoreApi_v1";
import LibUtils from "lib/LibUtils";
import { IAdvFilterParams, IAdvFilterResult } from "views/general/AdvancedFilter/interfaces";

export interface ICatalogFilterOptions extends IAdvFilterParams<LmsTrainingOrder> {
}

export function getClearFilter(): ICatalogFilterOptions {
    return {
        searchText: "",
        advFilters: [],
        order: LmsTrainingOrder.Name
    };
}

///
export function clearAdvFilter(item: IAdvFilterResult, viewFilter: ICatalogFilterOptions): ICatalogFilterOptions {
    return {
        ...getClearFilter(),
        advFilters: [],
    };
}

///
export function getClearFilterOnHideAdvFilter(viewFilter: ICatalogFilterOptions): ICatalogFilterOptions {
    const clearAdvFilters = viewFilter.advFilters.filter(x => x.quickFilter != null);

    return {
        ...getClearFilter(),
        advFilters: clearAdvFilters,
    };
}

export function filterChanged(filter: ICatalogFilterOptions, compare: ICatalogFilterOptions) {
    return filter.searchText != compare.searchText
        || filter.order != compare.order
        || !LibUtils.compareObjects(filter.advFilters.map(x => x.command), compare.advFilters.map(x => x.command))
        || !LibUtils.compareObjects(filter.advFilters, compare.advFilters);
}
